import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent } from '../../../../Core';

let ResultsSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <NamePrefixModifier appendNamePrefix="Results">
      <ListFieldSection>
        <Field input={<TextOutput />} name="MaximumAppliedPressure" />
        <NamePrefixModifier appendNamePrefix={`Cycles[0]`}>
          <Field input={<TextOutput />} name="MaximumDeformation" />
          <Field input={<TextOutput />} name="PressureCBRSettlement" />
          <Field input={<TextOutput />} name="ModulusOfSubgradeReaction" />
          <Field input={<TextOutput />} name="EquivalentCBR" />
        </NamePrefixModifier>
      </ListFieldSection>
      <ListFieldSection heading="Moisture Content">
        <Field input={<TextOutput />} name="MoistureContent" />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

const ResultsSection = withInjectedProps(ResultsSectionBase);

export default ResultsSection;
export { ResultsSection };
